/**
 * Lets the sidebar row and the mobile top-bar icon open the palette without a shared
 * React ancestor. The palette subscribes while mounted.
 */
const listeners = new Set<() => void>()

export function openGlobalSearch(): void {
  listeners.forEach((listener) => listener())
}

export function onOpenGlobalSearch(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
